module.exports = __webpack_public_path__ + "static/media/holy_intervention.0afe9fc9.png";